import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosFormInstance } from "../../../api/axiosInstance";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

// const axiosInstance = axios.create({
//   baseURL: "http://108.181.165.29:8067/api",
//   headers: {
//     "Content-Type": "multipart/form-data",
//   },
// });
export const parseResume = createAsyncThunk(
  "products/parseResume",
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("resumeFile", file);
      const response = await axiosFormInstance.post(
        "common/parseresume",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to upload file");
    }
  }
);

export const getparseStatus = createAsyncThunk(
  "products/getparseStatus",
  async (statusData, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.get(
        endpoints.getallparsingdata,
        statusData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: {
    resumeData: null,
    parseStatus: null,
    resumeParseType: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetParseResume: (state) => {
      state.resumeData = null;
      state.resumeParseType = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(parseResume.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(parseResume.fulfilled, (state, action) => {
        state.loading = false;
        state.resumeData = action.payload.data;
        state.resumeParseType = action.payload.parsingType; 
      })
      .addCase(parseResume.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getparseStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getparseStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.parseStatus = action.payload.data;
      })
      .addCase(getparseStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetParseResume } = productsSlice.actions;
export default productsSlice.reducer;
